import { mapActions } from "vuex";
import { TokenService } from "@/api/storage.js";
const errorsLogin = ["Usuário ou senha inválidos.", "Senha expirada, um email de recuperação foi enviado."];
export const LoadingRequest = {
  methods: {
    ...mapActions(["hasLoading", "showAlertNotification"]),
    async withLoading(request) {
      try {
        this.hasLoading(true);
        return await request;
      } catch (error) {
        // Verifica se tem error.response
        // Se tiver details, mostra description + details
        // se não, utiliza error_description.
        // Se der 401 e tiver token, quer dizer que
        // rodou refresh token e deu sucesso, e
        // assim não precisa mostrar alerta.
        const errorRefreshToken =
          error.response?.status == 401 &&
          !errorsLogin.includes(error.response.data.error_description);

        if (TokenService.getToken() && errorRefreshToken) {
          return Promise.reject(error);
        }

        var errorMessage = "Ocorreu um erro no sistema.";

        if (error.response) {
          if (errorRefreshToken) {
            errorMessage =
              "Login expirado, faça login novamente para continuar.";
          } else if (
            error.response.data.details &&
            error.response.data.details.length > 0
          ) {
            var errorMessagePrefix = "";
            if (error.response.data.error_description != "Chamada inválida.") {
              errorMessagePrefix = error.response.data.error_description + " ";
            }

            errorMessage =
              errorMessagePrefix +
              error.response.data.details.reduce(
                (acc, { message }) => acc.concat(`${message}\n`),
                ""
              );
          } else {
            errorMessage = error.response.data.error_description;
          }
        }

        this.showAlertNotification({
          message: errorMessage,
          type: "error"
        });

        return Promise.reject(error);
      } finally {
        this.hasLoading(false);
      }
    },
    getUploadFilePayload(file) {
      const payload = new FormData();
      payload.append("arquivo", file);
      return payload;
    }
  }
};
